import React from "react"
import {
  BadgeElement,
  BadgeElementType,
  BadgeShapeData,
} from "sharedTypes/badge"
import { EDITOR_RESOLUTION } from "../utils/constants"
import ShapeSVGWrapper, { getShapeStrokeProps } from "./ShapeSVGWrapper"

type Props = {
  element: BadgeElement
  scaleFactor?: number
}

const BadgeRectangle = ({
  element,
  scaleFactor = EDITOR_RESOLUTION,
}: Props) => {
  if (element.type !== BadgeElementType.RECTANGLE) return null

  const data = element.data as BadgeShapeData
  const thicknessPx = data.thickness * scaleFactor

  return (
    <ShapeSVGWrapper width={element.width} height={element.height} scaleFactor={scaleFactor}>
      <rect
        x={thicknessPx / 2}
        y={thicknessPx / 2}
        width={element.width * scaleFactor - thicknessPx}
        height={element.height * scaleFactor - thicknessPx}
        {...getShapeStrokeProps(data, thicknessPx)}
      />
    </ShapeSVGWrapper>
  )
}

export default BadgeRectangle
